import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Star, Reveal, Label, GoldButton } from "../components/primitives";
import { ScriptureMarquee } from "../components/ScriptureMarquee";
import { SERVICES } from "../data";

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-40 md:pt-52 pb-16 relative z-10">
        <Reveal><Label>Our craft</Label></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif text-6xl md:text-8xl lg:text-9xl font-[200] leading-[0.9] mt-8">
            Services
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-white/50 text-lg md:text-xl max-w-2xl mt-8 leading-relaxed">
            Six disciplines, held to a single standard of excellence. Whatever your story, we have
            the craft to tell it beautifully.
          </p>
        </Reveal>
      </section>

      <section className="relative z-10 py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-px bg-[#D4A843]/15 border hairline">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon];
            const flip = i % 2 === 1;
            return (
              <Reveal key={s.id}>
                <div
                  data-testid={`service-row-${s.id}`}
                  className={`bg-[#0D1220] grid md:grid-cols-2 items-center group ${flip ? "md:[direction:rtl]" : ""}`}
                >
                  <div className="overflow-hidden aspect-[16/10] md:aspect-auto md:h-[420px] [direction:ltr]">
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-700"
                    />
                  </div>
                  <div className="p-10 md:p-16 [direction:ltr]">
                    <div className="flex items-center gap-4 mb-8">
                      <Icon strokeWidth={1} className="w-9 h-9 text-gold" />
                      <span className="font-serif text-2xl text-white/20">0{i + 1}</span>
                    </div>
                    <h2 className="font-serif text-4xl md:text-6xl font-[300] mb-6">{s.title}</h2>
                    <p className="text-white/50 leading-relaxed text-lg max-w-md">{s.desc}</p>
                    <Link
                      to="/contact"
                      data-testid={`service-quote-${s.id}`}
                      className="inline-flex items-center gap-3 mt-10 label text-gold link-underline group/q"
                    >
                      Request a quote
                      <span className="transition-transform duration-300 group-hover/q:translate-x-1">&#8594;</span>
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <ScriptureMarquee />

      <section className="py-32 text-center px-6 relative z-10">
        <Reveal>
          <Star size={24} className="text-gold mx-auto mb-8 star-spin" />
          <h2 className="font-serif text-5xl md:text-7xl font-[200]">Have a project in mind?</h2>
          <div className="mt-12 flex justify-center">
            <Link to="/contact"><GoldButton data-testid="services-cta">Request a quote</GoldButton></Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
